// STATEFUL KENDO GRID - KEEPS DATA RECORDS AND CHANGES IN INTERNAL STATE

import { process } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import * as React from 'react';

import { GridToolbar } from '@progress/kendo-react-grid';
import { Button, SplitButton, MenuItem } from 'react-bootstrap';
import { ReminderBidActionKeys, } from '../common/grid/grid-cell-components/gridcell-dropdown-actions-bids-reminders';
import { Formatters } from '../common/formatters';

export const withState = (WrappedGrid) => {
    return class StatefulGrid extends React.Component<any, any> {
        public constructor(props: any) {
            super(props);

            this.state = {
                skip: 0,
                take: 20,
                filter: undefined,
                group: undefined,
                sort: undefined,
            };
        }

        public getSelectedRows(data: any, selectedField: any) {
            const selected = _.filter(data, [selectedField, true]);
            return selected;
        }

        public handleButtonRemoveReminders(a: any, k: any = '') {
            const { selectedField, data, handleButtonClick, children, ...rest } = this.props;

            const selected = this.getSelectedRows(data, selectedField);
            const hasSelected = (_.size(selected) > 0) ? true : false;

            if (hasSelected) {
                this.props.handleRemoveReminders(selected, k);
            }
        }

        public handleButtonSetBidStatuses(a: any, k: any = '') {
            const { selectedField, data, handleButtonClick, children, ...rest } = this.props;

            const selected = this.getSelectedRows(data, selectedField);
            const hasSelected = (_.size(selected) > 0) ? true : false;

            if (hasSelected) {
                this.props.handleSetStatusReminders(selected, k);
            }
        }

        public handleButtonSendReminderEmails(a: any, k: any = '') {
            const { selectedField, data, handleButtonClick, children, ...rest } = this.props;

            const selected = this.getSelectedRows(data, selectedField);
            const hasSelected = (_.size(selected) > 0) ? true : false;

            if (hasSelected) {
                this.props.handleSendReminderEmails(selected, k);
            }
        }

        public render() {
            const { selectedField, data, handleButtonClick, appTextFunc, children, ...rest } = this.props;

            const selected = this.getSelectedRows(data, selectedField);

            let buttonProps = {
                bsStyle: 'info',
                bsSize: 'sm',
                disabled: false,
                title: appTextFunc('set-all-statuses'),
            };

            return (
                <WrappedGrid
                    {...this.props}
                    {...this.state}
                    data={process(data, this.state)}
                    filterChange={(e) => { this.setState({ filter: e.filter }); }}
                    sortChange={(e) => { this.setState({ sort: e.sort }); }}
                    pageChange={(e) => { this.setState({ skip: e.page.skip, take: e.page.take }); }}
                    groupChange={(e) => { this.setState({ group: e.group }); }}

                    selectionChange={(e) => {
                        const prevVal = Formatters.getBool(e.dataItem, selectedField);
                        const nextVal = !prevVal;
                        e.dataItem[selectedField] = nextVal;

                        this.forceUpdate();
                    }}
                >
                    <GridToolbar>
                        <Button className="reminder-bids-grid-toolbar-button" disabled={false} bsSize="sm" bsStyle={'info'} onClick={(e) => { this.handleButtonRemoveReminders(e); }}>
                            <i className="fa fa-calendar-times-o" /> {appTextFunc('remove-any-reminders')}
                        </Button>

                        <Button className="reminder-bids-grid-toolbar-button" disabled={false} bsSize="sm" bsStyle={'info'} onClick={(e) => { this.handleButtonSendReminderEmails(e); }}>
                            <i className="fa fa-envelope-o" /> {appTextFunc('send-reminder-email')}
                        </Button>

                        <SplitButton
                            {...buttonProps}
                            id="split-button-reminder-bids-grid-toobar-status"
                            disabled={false}
                        >
                            <MenuItem
                                key={`reminderbids-grid-toolbar-splitbutton-id-1`}
                                eventKey={ReminderBidActionKeys.setStatus3YrPendingStart}
                                onSelect={(k, e) => { this.handleButtonSetBidStatuses(e, k); }}
                            >
                                {appTextFunc('3-yr-pending-start')}
                            </MenuItem>

                            <MenuItem
                                key={`reminderbids-grid-toolbar-splitbutton-id-2`}
                                eventKey={ReminderBidActionKeys.setStatus3YrRenewal}
                                onSelect={(k, e) => { this.handleButtonSetBidStatuses(e, k); }}
                            >
                                {appTextFunc('3-yr-renewal')}
                            </MenuItem>
                        </SplitButton>
                    </GridToolbar>
                    {children}
                </WrappedGrid >
            );
        }
    };
};



// WEBPACK FOOTER //
// ./src/reminder-bids/with-state.tsx